import type { PayloadAction } from '@reduxjs/toolkit';

import { ICMSBreadcrumb } from 'shared/types/Breadcrumbs';
import { INavigationTheme } from 'styles/theme/navigation';
import { IPageLayoutState } from 'store/types/pageLayoutTypes';

export const setIsHeaderVisible = (state: IPageLayoutState, action: PayloadAction<boolean>) => {
  // In PageLayout, we always set the Header hidden when we're in the app (webview)
  // Keeping the redux state consistent by not allowing the state to be changed
  if (state.isInApp) state.isHeaderVisible = false;
  else state.isHeaderVisible = action.payload;
};

export const setIsFooterVisible = (state: IPageLayoutState, action: PayloadAction<boolean>) => {
  // In PageLayout, we always set the Footer hidden when we're in the app (webview)
  // Keeping the redux state consistent by not allowing the state to be changed
  if (state.isInApp) state.isFooterVisible = false;
  else state.isFooterVisible = action.payload;
};

export const setIsMenuVisible = (state: IPageLayoutState, action: PayloadAction<boolean>) => {
  state.isMenuVisible = action.payload;
};

export const setIsMobileSearchOpen = (state: IPageLayoutState, action: PayloadAction<boolean>) => {
  state.isMobileSearchOpen = action.payload;
};

export const setToggleCurrentTheme = (
  state: IPageLayoutState,
  action: PayloadAction<INavigationTheme>,
) => {
  state.currentTheme = action.payload;
};

export const setMultipleLayoutOptions = (
  state: IPageLayoutState,
  action: PayloadAction<{
    isHeaderVisible?: boolean;
    isFooterVisible?: boolean;
    isInApp?: boolean;
    isMenuVisible?: boolean;
    currentTheme?: INavigationTheme;
  }>,
) => {
  for (const key of Object.keys(action.payload)) {
    if (key in state) {
      state[key] = action.payload[key];
    }
  }
};

export const setMenuNavigation = (
  state: IPageLayoutState,
  action: PayloadAction<{ calendar: ICMSBreadcrumb; navigation: ICMSBreadcrumb }>,
) => {
  state.menuNavigation = action.payload;
};
